import { render, staticRenderFns } from "./TheMenuItem.vue?vue&type=template&id=427c690a&"
import script from "./TheMenuItem.vue?vue&type=script&lang=js&"
export * from "./TheMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuItem.vue?vue&type=style&index=0&id=427c690a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports